// 余额明细（销售合同下的业务单据页面配置）
import {
  getContractBalanceListData,
  saveContractBalanceData,
  saveContractBalanceEditData,
  saveContractBalanceDeleteData
} from "../../api/api.js";

export default {
  key: "balance",
  title: "余额明细",
  short: "余额明细",
  icon: "balance-list-o",
  listFn: getContractBalanceListData,
  saveFn: saveContractBalanceData,
  editFn: saveContractBalanceEditData,
  deleteFn: saveContractBalanceDeleteData,
  // 只读单据：由支付/退款/转单等流水自动生成，不允许手工新增 / 编辑 / 删除（列表只保留「点卡片看详情」）
  readonly: true,
  // 卡片标题：变动类型 · 金额
  titleFields: ["change_type", "type_name", "amount", "remark"],
  fields: [
    {
      prop: "change_type", label: "变动类型", type: "select", required: true, group: "余额变动",
      options: [
        { label: "充值", value: "充值" },
        { label: "消费", value: "消费" },
        { label: "退款", value: "退款" },
        { label: "调整", value: "调整" }
      ]
    },
    { prop: "amount", label: "金额", type: "number", group: "余额变动" },
    { prop: "remark", label: "备注", type: "textarea", group: "余额变动" }
  ]
};



// WEBPACK FOOTER //
// ./src/pages/contract/Balances.js